var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealthCheckIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9932 2.1635C6.7619 -2.412 0.110422 1.60816 0.00135253 7.05814C-0.0264422 8.44708 0.374496 9.80002 1.17258 11.0473H6.34549L7.26558 9.51378C7.53275 9.06855 8.17929 9.05421 8.4616 9.49808L10.4029 12.5486L13.2326 6.5748C13.4794 6.05355 14.2149 6.037 14.4871 6.54246L16.9128 11.0473H22.8138C27.1851 4.21534 18.5459 -3.56771 11.9932 2.1635Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8742 12.084L13.9086 8.43359L11.129 14.3014C10.8926 14.8007 10.1971 14.844 9.9005 14.3779L7.88643 11.213L7.3468 12.1124C7.21973 12.3242 6.99091 12.4537 6.74394 12.4537H2.28516C2.42493 12.6 1.68 11.8566 11.4976 21.6234C11.7718 21.8962 12.2151 21.8962 12.4893 21.6234C22.1559 12.0068 21.5623 12.5997 21.7018 12.4537H16.4932C16.2345 12.4538 15.9968 12.3117 15.8742 12.084Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthCheckIn);
export default __webpack_public_path__ + "static/media/health-check-in.b2fce8dadfa28ef8687fa3b02feab6d1.svg";
export { ForwardRef as ReactComponent };